// extracted by mini-css-extract-plugin
export var icon = "_48-1";
export var subtext = "_48-0";